// import React, { useState } from "react";
// import "./Contact.css";
// import emailjs from "emailjs-com";

// const ContactPage = () => {
//   const [form, setForm] = useState({ name: "", email: "", message: "" });
//   const [errors, setErrors] = useState({});
//   const [submitted, setSubmitted] = useState(false);

//   const validate = () => {
//     const errs = {};
//     if (!form.name.trim()) errs.name = "Your name is required.";
//     if (!form.email.trim()) {
//       errs.email = "Your e-mail is required.";
//     } else if (!/\S+@\S+\.\S+/.test(form.email)) {
//       errs.email = "Please enter a valid e-mail.";
//     }
//     if (!form.message.trim()) errs.message = "Message is required.";
//     return errs;
//   };

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const errs = validate();
//     if (Object.keys(errs).length === 0) {
//       setErrors({});
//       emailjs
//         .send(
//           "service_pbgoiql",     
//           "template_z395lk6",    
//           form,
//           "m2R65_Wa7RGzc2dvb"   
//         )
//         .then(
//           (result) => {
//             console.log("Email sent!", result.text);
//             setSubmitted(true);
//             setForm({ name: "", email: "", message: "" });
//           },
//           (error) => {
//             console.error("Email failed to send:", error.text);
//             setSubmitted(false);
//           }
//         );
//     } else {
//       setErrors(errs);
//       setSubmitted(false);
//     }
//   };

//   return (
//     <div className="contact-page">
//       <h1>Contact</h1>
//       <p>
//         To Get In Touch With Us For Your Next Project Or Any General Query Please
//         Follow The Below Contact Details!
//       </p>

//       <div className="contact-info">
//         <div>
//           <h3>OUR ADDRESS</h3>
//           <p>Krishnagiri<br /> Tamil Nadu<br /> India</p>
//         </div>
//         <div>
//           <h3>E-MAIL</h3>
//           <p>Estimaterebbar@outlook.com</p>
//           <a href="mailto:Estimaterebbar@outlook.com" className="btn-email">
//             Send us e-mail
//           </a>
//         </div>
//         <div>
//           <h3>CONTACT-US</h3>
//           <p>+91 8667278873</p>
//           <a href="tel:8667278873" className="btn-call">
//             Send us a message
//           </a>
//         </div>
//       </div>

//       <form className="contact-form" onSubmit={handleSubmit} noValidate>
//         <h2>Send us a message</h2>
//         {submitted && (
//           <div className="success-msg">Thank you! Your message has been sent.</div>
//         )}

//         <label htmlFor="name">Your name</label>
//         <input
//           type="text"
//           id="name"
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           className={errors.name ? "input-error" : ""}
//           placeholder="Enter your name"
//         />
//         {errors.name && <span className="error">{errors.name}</span>}

//         <label htmlFor="email">Your e-mail</label>
//         <input
//           type="email"
//           id="email"
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           className={errors.email ? "input-error" : ""}
//           placeholder="Enter your email"
//         />
//         {errors.email && <span className="error">{errors.email}</span>}

//         <label htmlFor="message">Message</label>
//         <textarea
//           id="message"
//           name="message"
//           value={form.message}
//           onChange={handleChange}
//           className={errors.message ? "input-error" : ""}
//           placeholder="Write your message"
//           rows="5"
//         />
//         {errors.message && <span className="error">{errors.message}</span>}

//         <button type="submit">Send Message</button>
//       </form>
//     </div>
//   );
// };

// export default ContactPage;
import React, { useState } from "react";
import emailjs from "emailjs-com";

const ContactPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // ================= Validation =================

  const validate = () => {
    const errs = {};

    if (!form.name.trim()) {
      errs.name = "Name is required";
    }

    if (!form.phone.trim()) {
      errs.phone = "Phone number is required";
    }

    if (!form.email.trim()) {
      errs.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      errs.email = "Enter a valid email address";
    }

    if (!form.message.trim()) {
      errs.message = "Message is required";
    }

    return errs;
  };

  // ================= Handle Change =================

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // ================= Submit =================

  const handleSubmit = (e) => {
    e.preventDefault();

    const errs = validate();

    if (Object.keys(errs).length === 0) {

      setErrors({});
      setSubmitted(false);
      setErrorMsg("");

      emailjs
        .send(
          "service_pbgoiql",
          "template_z395lk6",
          form,
          "m2R65_Wa7RGzc2dvb"
        )
        .then(() => {
          setSubmitted(true);

          setForm({
            name: "",
            phone: "",
            email: "",
            message: "",
          });
        })
        .catch(() => {
          setErrorMsg("Failed to send message. Please try again.");
        });

    } else {

      setErrors(errs);
      setSubmitted(false);

    }
  };
    return (
    <div className="bg-gray-50">

      {/* ================= HERO SECTION ================= */}

      <section className="relative bg-gradient-to-r from-slate-800 to-slate-700 py-24">

        <div className="max-w-7xl mx-auto px-6 text-center">

          <div className="flex justify-center items-center gap-4 mb-6">

            <div className="w-20 h-[2px] bg-amber-400"></div>

            <span className="uppercase tracking-[5px] text-amber-400 font-semibold">
              Contact Us
            </span>

            <div className="w-20 h-[2px] bg-amber-400"></div>

          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-white">
            Let's Build Something Great
          </h1>

          <p className="mt-8 max-w-3xl mx-auto text-lg text-gray-200 leading-8">
           Tell us about your upcoming project. Contact EDRS today to get professional help with rebar estimating, Excel calculations, and aSa Estimating.
          </p>

        </div>

      </section>

      {/* ================= CONTACT INFO ================= */}

      <section className="-mt-14 relative z-10">

        <div className="max-w-7xl mx-auto px-6">

          <div className="grid md:grid-cols-3 gap-8">

            {/* Address */}

            <div className="bg-white rounded-2xl shadow-xl p-8 text-center">

  <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 flex items-center justify-center text-3xl">
    📍
  </div>

  <h3 className="text-2xl font-bold text-slate-900 mt-6">
    Office Address
  </h3>

  <p className="mt-4 text-gray-600 leading-8">
  Krishnagiri, Tamil Nadu
  <br />
  India
</p>

  <a
  href="https://www.google.com/maps/search/?api=1&query=AAHAA+MILK+COLLECTION+CENTER+%26+MJN+MOBILE+SERVICE"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block mt-6 bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-lg transition font-semibold"
>
  📍 Visit Our Office
</a>

</div>

            {/* Email */}

            <div className="bg-white rounded-2xl shadow-xl p-8 text-center">

              <div className="w-16 h-16 mx-auto rounded-full bg-blue-100 flex items-center justify-center text-3xl">
                📧
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-6">
                Email Us
              </h3>

              <p className="mt-4 text-gray-600 break-all">
                Estimaterebbar@outlook.com
              </p>

              <a
                href="mailto:Estimaterebbar@outlook.com"
                className="inline-block mt-6 bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg transition"
              >
                Send Email
              </a>

            </div>

            {/* Phone */}

            <div className="bg-white rounded-2xl shadow-xl p-8 text-center">

              <div className="w-16 h-16 mx-auto rounded-full bg-green-100 flex items-center justify-center text-3xl">
                📞
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-6">
                Call Us
              </h3>

              <p className="mt-4 text-gray-600">
                +91 86672 78873
              </p>

              <a
                href="tel:+918667278873"
                className="inline-block mt-6 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition"
              >
                Call Now
              </a>

            </div>

          </div>

        </div>

      </section>
            {/* ================= CONTACT FORM ================= */}

      <section className="py-24">

        <div className="max-w-7xl mx-auto px-6">

          <div className="grid lg:grid-cols-2 gap-16 items-start">

            {/* Left Side */}

            <div>

              <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
                Get In Touch
              </span>

              <h2 className="text-5xl font-bold text-slate-900 mt-4">
                Send Us a Message
              </h2>

              <p className="mt-8 text-lg text-gray-600 leading-8">
                Whether you need Rebar Estimation,
                Excel Estimation,
                aSa Estimating,
                or have any general enquiry,
                our team is ready to assist you.
              </p>

              <div className="mt-12 space-y-8">

                <div className="flex items-start gap-5">

                  <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center text-2xl">
                    📍
                  </div>

                  <div>

                    <h3 className="font-bold text-xl">
                      Office
                    </h3>

                    <p className="text-gray-600 mt-2">
                      Krishnagiri,
                      Tamil Nadu,
                      India
                    </p>

                  </div>

                </div>

                <div className="flex items-start gap-5">

                  <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center text-2xl">
                    📧
                  </div>

                  <div>

                    <h3 className="font-bold text-xl">
                      Email
                    </h3>

                    <p className="text-gray-600 mt-2">
                      Estimaterebbar@outlook.com
                    </p>

                  </div>

                </div>

                <div className="flex items-start gap-5">

                  <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center text-2xl">
                    📞
                  </div>

                  <div>

                    <h3 className="font-bold text-xl">
                      Phone
                    </h3>

                    <p className="text-gray-600 mt-2">
                      +91 86672 78873
                    </p>

                  </div>

                </div>

              </div>

            </div>

            {/* Right Side Form */}

            <div className="bg-white rounded-3xl shadow-2xl p-10">

              <h3 className="text-3xl font-bold text-slate-900 mb-8">
                Contact Form
              </h3>

              {submitted && (
                <div className="mb-6 bg-green-100 text-green-700 p-4 rounded-lg">
                  ✅ Thank you! Your message has been sent successfully.
                </div>
              )}

              {errorMsg && (
                <div className="mb-6 bg-red-100 text-red-700 p-4 rounded-lg">
                  {errorMsg}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">

                <div>

                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-amber-400"
                  />

                  {errors.name && (
                    <p className="text-red-500 mt-2 text-sm">
                      {errors.name}
                    </p>
                  )}

                </div>

                <div>

                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={form.phone}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-amber-400"
                  />

                  {errors.phone && (
                    <p className="text-red-500 mt-2 text-sm">
                      {errors.phone}
                    </p>
                  )}

                </div>

                <div>

                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={form.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-amber-400"
                  />

                  {errors.email && (
                    <p className="text-red-500 mt-2 text-sm">
                      {errors.email}
                    </p>
                  )}

                </div>

                <div>

                  <textarea
                    rows="6"
                    name="message"
                    placeholder="Write your message..."
                    value={form.message}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-amber-400"
                  ></textarea>

                  {errors.message && (
                    <p className="text-red-500 mt-2 text-sm">
                      {errors.message}
                    </p>
                  )}

                </div>

                <button
                  type="submit"
                  className="w-full bg-amber-500 hover:bg-amber-600 text-white py-4 rounded-xl font-semibold text-lg transition"
                >
                  Send Message
                </button>

              </form>

            </div>

          </div>

        </div>

      </section>
            {/* ================= GOOGLE MAP ================= */}

      <section className="py-20 bg-white">

        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-12">

            <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
              Find Us
            </span>

            <h2 className="text-5xl font-bold text-slate-900 mt-4">
              Our Location
            </h2>

            <p className="mt-6 text-gray-600 max-w-2xl mx-auto">
              Visit our office or contact us online for all your
              Rebar Estimation
            </p>

          </div>

          <div className="rounded-3xl overflow-hidden shadow-2xl">

            <iframe
              title="EDRS Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d487.22740977995164!2d78.2896444503417!3d12.327947793695698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bac39840059a89d%3A0xac16b7d65f02c2b2!2sAAHAA%20MILK%20COLLECTION%20CENTER%20%26%20MJN%20MOBILE%20SERVICE!5e0!3m2!1sen!2sin!4v1783598649687!5m2!1sen!2sin"referrerpolicy="strict-origin-when-cross-origin"
              width="100%"
              height="500"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>

          </div>

        </div>

      </section>

      {/* ================= CTA ================= */}

      {/* ================= CALL TO ACTION ================= */}

<section className="py-20 bg-slate-50">

  <div className="max-w-6xl mx-auto px-6 lg:px-8">

    <div className="bg-white rounded-2xl border border-gray-200 shadow-lg p-10 lg:p-14">

      <div className="grid lg:grid-cols-2 gap-10 items-center">

        {/* Left Side */}

        <div>

          <span className="text-amber-500 uppercase tracking-[4px] font-semibold">
            Get Started
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-4 leading-tight">
            Let's Discuss Your
            <span className="block text-amber-500">
              Next Project
            </span>
          </h2>

          <p className="mt-6 text-gray-600 leading-8 text-lg">
            We provide reliable Rebar Estimation, Excel Estimation,
            and aSa Estimating with accuracy, timely delivery,
            and professional support for every construction project.
          </p>

          <div className="flex flex-wrap gap-4 mt-8">

            <a
              href="tel:+918667278873"
              className="bg-amber-500 hover:bg-amber-600 text-white px-7 py-3 rounded-lg font-semibold transition"
            >
              📞 Call Us
            </a>

            <a
              href="mailto:Estimaterebbar@outlook.com"
              className="border border-slate-300 hover:border-amber-500 hover:text-amber-600 px-7 py-3 rounded-lg font-semibold transition"
            >
              📧 Email Us
            </a>

          </div>

        </div>

        {/* Right Side */}

        <div className="grid grid-cols-2 gap-5">

          <div className="bg-slate-100 rounded-xl p-6 text-center">

            <h3 className="text-4xl font-bold text-amber-500">
              600+
            </h3>

            <p className="mt-2 text-gray-700 font-medium">
              Projects Completed
            </p>

          </div>

          <div className="bg-slate-100 rounded-xl p-6 text-center">

            <h3 className="text-4xl font-bold text-amber-500">
              60K+
            </h3>

            <p className="mt-2 text-gray-700 font-medium">
              Tons Estimated
            </p>

          </div>

          <div className="bg-slate-100 rounded-xl p-6 text-center">

            <h3 className="text-4xl font-bold text-amber-500">
              Since
            </h3>

            <p className="mt-2 text-gray-700 font-medium">
              2019
            </p>

          </div>

          <div className="bg-slate-100 rounded-xl p-6 text-center">

            <h3 className="text-4xl font-bold text-amber-500">
              100%
            </h3>

            <p className="mt-2 text-gray-700 font-medium">
              Quality Focused
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>
    </div>
  );
};

export default ContactPage;